import React, { useState } from "react";
import styles from "./Contact.module.css";
import Typewriter from "typewriter-effect";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import EmailIcon from "@mui/icons-material/Email";
import InstagramIcon from "@mui/icons-material/Instagram";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import TwitterIcon from "@mui/icons-material/Twitter";
import emailjs from "emailjs-com";

const Contact = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [msg, setMsg] = useState("");

  const copy = (link) => {
    var dummy = document.createElement("input"),
      text = link;

    document.body.appendChild(dummy);
    dummy.value = text;
    dummy.select();
    document.execCommand("copy");
    document.body.removeChild(dummy);
    toast.info("Link copied to clipboard", {
      position: toast.POSITION.BOTTOM_CENTER,
      style: {
        backgroundColor: "#142850",
        border: "2px solid #00fff5",
        boxShadow: "0 0px 15px rgb(0, 255, 245, 0.5)",
        color: "#00fff5",
      },
      icon: false,
      autoClose: 3000,
      hideProgressBar: true,
    });
  };

  const sendEmail = () => {
    if (!name) {
      setMsg("Please enter your Name!");
      setTimeout(() => {
        setMsg("");
      }, 4000);
      return;
    }
    if (!email) {
      setMsg("Please enter an Email!");
      setTimeout(() => {
        setMsg("");
      }, 4000);
      return;
    }
    if (!message) {
      setMsg("Please enter a message you want to send!");
      setTimeout(() => {
        setMsg("");
      }, 4000);
      return;
    }
    emailjs.send(
      "gmail",
      "portfoliocontact",
      {
        from_name: name,
        email: email,
        message: message,
      },
      "user_Icrd8J7AmJASruRZ2I4rF"
    );
    setName("");
    setEmail("");
    setMessage("");
    setMsg("Message sent, will contact you soon.");
    setTimeout(() => {
      setMsg("");
    }, 4000);
  };

  return (
    <div className={styles.contactMainDiv}>
      <h1>
        <Typewriter
          style={{ fontWeight: "bold" }}
          options={{
            autoStart: true,
            loop: true,
            delay: 40,
            strings: ["Contact()"],
          }}
        />
      </h1>
      <div className={styles.contactDiv}>
        <div className={styles.left}>
          <div className={styles.linkItem}>
            <a
              title="Gmail"
              href="mailto:aniani4848@gmail.com"
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => window.open(e.currentTarget.href, "_blank")}
            >
              <EmailIcon className={styles.iconStyle} />
              <p>aniani4848@gmail.com</p>
            </a>
            <div
              onClick={() => {
                copy("mailto:aniani4848@gmail.com");
              }}
              className={styles.copyBtn}
            >
              Copy link
            </div>
          </div>
          <div className={styles.linkItem}>
            <a
              title="LinkedIn"
              href="https://www.linkedin.com/in/aniani4848/"
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => window.open(e.currentTarget.href, "_blank")}
            >
              <LinkedInIcon className={styles.iconStyle} />
              <p>Aniket Yadav</p>
            </a>
            <div
              onClick={() => {
                copy("https://www.linkedin.com/in/aniani4848/");
              }}
              className={styles.copyBtn}
            >
              Copy link
            </div>
          </div>
          <div className={styles.linkItem}>
            <a
              title="Github"
              href="https://github.com/aniketyadav44"
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => window.open(e.currentTarget.href, "_blank")}
            >
              <GitHubIcon className={styles.iconStyle} />
              <p>Aniketyadav44</p>
            </a>
            <div
              onClick={() => {
                copy("https://github.com/aniketyadav44");
              }}
              className={styles.copyBtn}
            >
              Copy link
            </div>
          </div>
          <div className={styles.linkItem}>
            <a
              title="Instagram"
              href="https://www.instagram.com/anikettsy/"
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => window.open(e.currentTarget.href, "_blank")}
            >
              <InstagramIcon className={styles.iconStyle} />
              <p>@anikettsy</p>
            </a>
            <div
              onClick={() => {
                copy("https://www.instagram.com/anikettsy/");
              }}
              className={styles.copyBtn}
            >
              Copy link
            </div>
          </div>
          <div className={styles.linkItem}>
            <a
              title="Gmail"
              href="https://twitter.com/AniketY8888"
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => window.open(e.currentTarget.href, "_blank")}
            >
              <TwitterIcon className={styles.iconStyle} />
              <p>@AniketY8888</p>
            </a>
            <div
              onClick={() => {
                copy("https://twitter.com/AniketY8888");
              }}
              className={styles.copyBtn}
            >
              Copy link
            </div>
          </div>
        </div>
        <div className={styles.right}>
          <p style={{ fontSize: "20px", textAlign: "center" }}>
            <strong>Get in touch, Leave a Message.</strong>
          </p>
          <input
            type="text"
            value={name}
            onChange={(e) => {
              setName(e.target.value);
            }}
            placeholder="Name"
          />
          <input
            type="text"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
            }}
            placeholder="Email"
          />
          <textarea
            rows="15"
            value={message}
            onChange={(e) => {
              setMessage(e.target.value);
            }}
            placeholder="Enter your message"
          />
          <button onClick={sendEmail}>Submit</button>
          <p
            style={{ fontSize: "15px", textAlign: "center", marginTop: "10px" }}
          >
            <strong>{msg}</strong>
          </p>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default Contact;
